import { convertGQLToProductJson } from 'utils/general'

/**
 * @info
 *
 * *The "store/shade-finder" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind product functionality.
 *
 * *This file*
 * This file outlines "mutations". Mutations are intended
 * to be as simple as possible. All modifications to the state
 * object should happen inside a mutation function. Each
 * of these functions must be synchronous. There should be nothing
 * that has a time delay, such as an AJAX request or a setTimeout.
 */

export default {
  setVtoStep (state, step) {
    state.step = step
  },
  setProducts (state, products) {
    state.products = products
  },
  setActiveProductIndex (state, index) {
    state.activeProductIndex = index
  },
  setFilterGroups (state, groups) {
    state.filterGroups = groups
  },
  setRecommendations (state, recommendations) {
    state.recommendations = recommendations
  },
  setRecommendationIds (state, skus) {
    state.recommendationIds = skus
  },
  setFiltersData (state, filterData) {
    state.filterData = filterData
  },
  setActiveGroup (state, activeGroup) {
    state.activeGroup = activeGroup
  },
  setActiveMicroCollectionTitle (state, title) {
    state.activeMicroCollectionTitle = title
  },
  setActiveMicroCollectionDescription (state, description) {
    state.activeMicroCollectionDescription = description
  },
  setActiveFilters (state, { key, value }) {
    state.activeFilters = {
      ...state.activeFilters,
      [key]: value
    }
  },
  resetFilterByKey (state, payload) {
    delete state.activeFilters[payload]
  }
}
